export default class SMonitor {

    constructor(smonitor){
        this.smonitorElm = smonitor;
        this.screenElm = this.smonitorElm.querySelector('.js-smonitor_screen');
        this._onAnimationEnd = this._onAnimationEnd.bind(this);
        this._init();
    }

    
    _init(){
        this._setupLoopAnimation();
    }


    _setupLoopAnimation(){
        this.smonitorElm.classList.remove('-init');

        const randomInterval = Math.random() * 5000 + 5000;

        setTimeout(() => {
            this.smonitorElm.classList.add('-playing');
            this.screenElm.addEventListener('animationend', this._onAnimationEnd);
            this._setupLoopAnimation();
        }, randomInterval);
    }


    _onAnimationEnd(){
        this.smonitorElm.classList.remove('-playing');
        this.screenElm.removeEventListener('animationend', this._onAnimationEnd);
    }
}
